import React from "react";
 

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
 
//import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";



import "./UnlockMore.css";

const UnlockMore = () => {
  // const [activeCard, setActiveCard] = useState("one");

  // const cardStyles = {
  //   first: activeCard === "one" ? { transform: "translate3d(0px, 0px, 0px)", opacity: 1, boxShadow: "0 20px 50px rgba(0,34,45,0.5)" } :
  //          activeCard === "two" ? { transform: "translate3d(110px, 80px, -60px)", opacity: 0.1, boxShadow: "none" } :
  //                                 { transform: "translate3d(0, -80px, 0px)", opacity: 0.6, boxShadow: "none" },
  //   second: activeCard === "one" ? { transform: "translate3d(0, -80px, 0px)", opacity: 0.6, boxShadow: "none" } :
  //           activeCard === "two" ? { transform: "translate3d(0px, 0px, 0px)", opacity: 1, boxShadow: "0 20px 50px rgba(0,34,45,0.5)" } :
  //                                   { transform: "translate3d(110px, 80px, -60px)", opacity: 0.1, boxShadow: "none" },
  //   third: activeCard === "one" ? { transform: "translate3d(110px, 80px, -60px)", opacity: 0.1, boxShadow: "none" } :
  //          activeCard === "two" ? { transform: "translate3d(0, -80px, 0px)", opacity: 0.6, boxShadow: "none" } :
  //                                 { transform: "translate3d(0px, 0px, 0px)", opacity: 1, boxShadow: "0 20px 50px rgba(0,34,45,0.5)" },
  // };

  return (
    <section className="UnlockMoreMain" id="trending">
      <div className="container">
        <div className='row '>
          <div className='col-lg-7 col-md-12 col-sm-12'>
            <div className='unlockMoreLeft'>
              <h2>Unlock More <span>Control <br />& Profitability</span> for Your<br /> Car Rental Business</h2>
              <p>
                If you’re a <span>GetAround</span> host, you know the challenges of operating within a marketplace—platform 
                fees, policy restrictions, and limited control over your business.</p>
                <p> Rentid was built to change the industry with a host-first platform designed to give you the freedom 
                  and flexibility to run your rental business on your own terms, with your best customers.
              </p>
            </div>
          </div>
          <div className='col-lg-5 col-md-12 col-sm-12'>
            <div className='unlockMoreRight'>


              
            <Swiper
            direction="vertical"  // Change this line to 'vertical' instead of verticle
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            loop={true}
          
           // slidesPerView="auto"
           slidesPerView={2.5}
           spaceBetween={-50}
            coverflowEffect={{ rotate: 0, stretch: 0, depth: 350, modifier: 2.5 }}
            pagination={{ clickable: true }}
            navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
            autoplay={{ delay: 1000, disableOnInteraction: false }}
            allowTouchMove={false}
            speed={3000}
            modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
          className="trending-slider"
        >
        <SwiperSlide className="swiper-slide trending-slide">
            <div className="unknownInner unknownInner_1">
                <img width="40px" src="/img/AnoucementPage/logo_r.svg" alt="icon"/> 
                <h2>Earn With Transparency </h2>
                <p>No marketplace commissions or hidden fees.</p>
            </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-slide trending-slide">
            <div className="unknownInner unknownInner_2">
              <img width="40px"  src="/img/AnoucementPage/logo_rocket.png" alt="icon"/> 
                <h2>Your Business, Your Pricing</h2>
                <p>Set your own rates and rental policies</p>
            </div>
        </SwiperSlide>

        <SwiperSlide className="swiper-slide trending-slide">
              <div className="unknownInner unknownInner_3">
                <img width="40px" src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>
                <h2>Better Renter Verification</h2>
                <p>AI-powered identity and validation checks </p>
              </div>
        </SwiperSlide>
   
        <SwiperSlide className="swiper-slide trending-slide">
            <div className="unknownInner unknownInner_4">
            <img width="40px" src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>
                <h2>Insurance &  Protection</h2>
                <p>Coverage for hosts and ride-share drivers. </p>
            </div>
        </SwiperSlide>
 
        <SwiperSlide className="swiper-slide trending-slide">
              <div className="unknownInner unknownInner_5">
              <img width="40px" src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>
                <h2>Your Own Booking System</h2>
                <p>Accept direct bookings and build your brand </p>
              </div>
        </SwiperSlide>  
        {/* end */}
        
        </Swiper>

         {/* <div className="trending-slider-control">
           <div className="swiper-button-prev slider-arrow">
             <IoArrowBackOutline />
           </div>
           <div className="swiper-button-next slider-arrow">
             <IoArrowForwardOutline />
           </div>
           <div className="swiper-pagination"></div>
         </div> */}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnlockMore;